import { createFileRoute } from "@tanstack/react-router";
import { CategoryManagePage } from "@client/components/settings/semantic-governance/category-manage-page";

export const Route = createFileRoute(
  "/_app/tenant-settings/semantic-governance/categories",
)({
  component: CategoryManagePage,
});
